<script setup lang="ts">
import { typographyBrandPalette, typographyColorPickerMode } from './policy';
import { addRecentColor, recentColors } from '@shared/recentColors';
import SharedBrandColorField from '@shared/components/BrandColorField.vue';

const props = defineProps<{ modelValue: string; label?: string }>();
const emit = defineEmits<{ (event: 'update:modelValue', value: string): void }>();

function apply(value: string) {
  emit('update:modelValue', value);
  addRecentColor(value);
}
</script>

<template>
  <SharedBrandColorField
    :model-value="props.modelValue"
    :mode="typographyColorPickerMode"
    :colors="typographyBrandPalette"
    :recent-colors="recentColors"
    :label="label"
    @update:model-value="apply"
  />
</template>
